import React from 'react';
import rehypeRaw from 'rehype-raw';
import remarkBreaks from 'remark-breaks';

import * as S from './styles';

interface Props {
  content: string;
}

export const MarkdownContent: React.FC<Props> = ({ content }) => {
  return (
    <S.ReactMarkdown remarkPlugins={[remarkBreaks]} rehypePlugins={[rehypeRaw]}>
      {content}
    </S.ReactMarkdown>
  );
};
